/**
 * Schedules the option's action after the editor finishes rendering.
 * @returns The editor change to make; `convertToNode: false` removes the trigger only when
 * the option has an action. Disabled options do not schedule an action or change the editor.
 */
export function prepareMentionSelection({ option, }) {
    if (option.disabled)
        return 'disabled';
    if (option.action) {
        // Lexical flushes the selection synchronously. Defer product actions so their renders
        // cannot interrupt that flush.
        setTimeout(() => {
            option.action?.();
        }, 0);
        if (option.convertToNode === false)
            return 'remove-trigger';
    }
    return 'insert-mention';
}
//# sourceMappingURL=prepareMentionSelection.js.map